import { useTranslation } from "react-i18next";
import { smallBtn } from "../../../styles";

interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Paginator({ page, totalPages, onPageChange }: Props) {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  return (
    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.75rem 1.5rem", borderTop: "1px solid var(--color-border)" }}>
      <button style={smallBtn} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        {t("admin.pagination.previous")}
      </button>
      <span style={{ fontSize: "0.85rem", color: "var(--color-text-muted)" }}>
        {t("admin.pagination.pageOf", { page, total: totalPages })}
      </span>
      <button style={smallBtn} disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
        {t("admin.pagination.next")}
      </button>
    </div>
  );
}
